import React, { Component } from 'react'

import DefaultPage from './DefaultPage'

import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner'

class LoadingV2 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <DefaultPage>
        <Spinner showText size={SpinnerSize.Large}/>
      </DefaultPage>
    );
  }
}

export default LoadingV2;